import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-71">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-72" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-[500px] bg-[#00d4aa] opacity-5 blur-[120px] rounded-full pointer-events-none" data-id="element-73" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-74">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-75">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-76">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00d4aa]/10 border border-[#00d4aa]/20 text-[#00d4aa] text-sm font-semibold mb-6" data-id="element-77">
              <span className="relative flex h-2 w-2" data-id="element-78">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00d4aa] opacity-75" data-id="element-79"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00d4aa]" data-id="element-80"></span>
              </span>
              Nueva Edición 2026
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-6 text-white" data-id="element-81">
              Tu hijo ya no{' '}
              <span className="text-gray-400 line-through decoration-red-500 decoration-4" data-id="element-82">
                "pierde el tiempo"
              </span>{' '}
              con los videojuegos: <br className="hidden lg:block" data-id="element-83" />
              <span className="text-gradient" data-id="element-84">
                Ahora está construyendo su carrera profesional
              </span>
            </h1>

            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-85">
              El método exacto para transformar la adicción a las pantallas en
              la habilidad técnica mejor pagada del mundo, sin castigos y aunque
              tú no sepas ni una línea de código.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8" data-id="element-86">
              <Button size="xl" className="group" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-87">
                QUIERO EL SISTEMA AHORA
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-88" />
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 text-sm text-gray-400" data-id="element-89">
              <div className="flex items-center gap-1" data-id="element-90">
                <CheckCircle2 className="h-4 w-4 text-[#00d4aa]" data-id="element-91" />
                <span data-id="element-92">Descarga Instantánea (PDF)</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-93">
                <CheckCircle2 className="h-4 w-4 text-[#00d4aa]" data-id="element-94" />
                <span data-id="element-95">Garantía de 7 días</span>
              </div>
            </div>
          </div>

          {/* Hero Image / Mockup */}
          <div className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-96">
            <div className="relative z-10 transform transition-transform hover:scale-[1.02] duration-500" data-id="element-97">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#00d4aa] to-blue-600 rounded-2xl blur opacity-30 animate-pulse" data-id="element-98"></div>
              <img src="https://cdn.magicpatterns.com/uploads/83kqigHm2BM2XC6ho5GueB/heylloyd-image-1772065442167.png" alt="De Gamer a Creador eBook Cover" className="relative rounded-2xl shadow-2xl border border-gray-800 w-full h-auto" data-id="element-99" />
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-10 -right-10 w-24 h-24 bg-[#f59e0b]/20 rounded-full blur-2xl animate-pulse delay-700" data-id="element-100"></div>
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#00d4aa]/20 rounded-full blur-2xl animate-pulse" data-id="element-101"></div>
          </div>
        </div>
      </div>
    </section>;
}